import { useCallback } from "react";
import { useSetAtom } from "jotai";
import {
  edgesAtom,
  nodesAtom,
  startStreamingProgressSetter,
  useCopilotDrawerState,
} from "@zapier/canvas-state";
import { handleCloseModalSetter } from "../atoms/handleCloseModalSetter";
import { usePromptToZslToCanvas } from "./usePromptToZslToCanvas";
import { outlineAtom, partialOutlineAtom } from "../atoms/outlineAtom";

export function useStreamingPrompt() {
  const { onPromptSubmit } = usePromptToZslToCanvas();
  const handleCloseModal = useSetAtom(handleCloseModalSetter);
  const setNodes = useSetAtom(nodesAtom);
  const setEdges = useSetAtom(edgesAtom);
  const setOutline = useSetAtom(outlineAtom);
  const setPartialOutline = useSetAtom(partialOutlineAtom);
  const startProgressAnimation = useSetAtom(startStreamingProgressSetter);
  const [, setIsCopilotOpen] = useCopilotDrawerState();

  const submitPrompt = useCallback(
    (args: any) => {
      setIsCopilotOpen(true);
      handleCloseModal();
      setOutline("");
      setPartialOutline("");
      setNodes([]);
      setEdges([]);
      startProgressAnimation();
      onPromptSubmit(args);

      return args;
    },
    [
      setIsCopilotOpen,
      handleCloseModal,
      setOutline,
      setPartialOutline,
      setNodes,
      setEdges,
      startProgressAnimation,
      onPromptSubmit,
    ],
  );

  return { submitPrompt };
}
